export const asDotMiniIcon = {
  data: `
<svg style="padding-left: 5px; padding-top: 5px;" class="flex items-center justify-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
    <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
</svg>`,
  name: 'mini/dot'
};
